// extracted by mini-css-extract-plugin
export default {"root":"ProductItem_root__vFifU","menuItemImage":"ProductItem_menuItemImage__3mwAg","rootIOS":"ProductItem_rootIOS__ZTAzI","rootMd":"ProductItem_rootMd__4Vw1S"};